import React from 'react';
import { TextField, TextFieldProps, Box, useTheme } from '@mui/material';

const GradientBorderTextField: React.FC<TextFieldProps> = (props) => {
	const theme = useTheme();
	const isLightTheme = theme.palette.mode === 'light';

	return (
		<Box
			sx={{
				padding: '2px',
				borderRadius: '20px',
				background: 'linear-gradient(90deg, #9149ff, #e600ff)',
				display: 'inline-block',
				width: '100%',
			}}
		>
			<TextField
				{...props}
				variant='outlined'
				fullWidth
				multiline
				maxRows={6}
				minRows={6}
				InputProps={{
					...props.InputProps,
					sx: {
						backgroundColor: isLightTheme ? '#F4F7FC' : 'black',
						borderRadius: '20px',
						color: theme.palette.text.primary,
						'& .MuiInputBase-inputMultiline': {
							color: theme.palette.text.primary,
							borderRadius: '20px',
							padding: '10px 14px',
							resize: 'none',
							overflowY: 'auto',
							maxHeight: '140px',
						},
						'&.MuiInputBase-root': {
							padding: 0,
						},
					},
				}}
				InputLabelProps={{
					style: {
						color: '#ccc',
					},
				}}
				sx={{
					'& .MuiOutlinedInput-notchedOutline': {
						border: 'none',
					},
					'& .MuiOutlinedInput-root': {
						borderRadius: '20px',
					},
				}}
			/>
		</Box>
	);
};

export default GradientBorderTextField;
